module.exports = __webpack_public_path__ + "img/score_verysmile.63b99eba.png";